import config from '../data/config.json';
import dict from '../data/dictionary.json';
import { downloadTemplateBody, downloadingTemplateBody, footerDescargaDatos,
	footerDescargando, footerDescargaDatosExito } from '../data/htmlTemplates.js';

import Mustache from 'mustache';
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import { stringify } from 'wkt';
import { saveAs } from 'file-saver';
import { point, booleanPointInPolygon, booleanIntersects } from '@turf/turf';
const ExcelJS = require('exceljs');
const JSZip = require("jszip");

import { Sesion, Datos, Layers } from '../main.js';
import { getMapLayer } from './map.js';
import { discoverPatchesInCell, processPatches, discoverPlotsInCell } from './dataManager.js';
import { featprovs } from './provinces.js';
import { getGrid } from './grid.js';
import { getLiteral, uriToLiteral, getDate, configurarModal } from './util.js';
import { initTimedEvent, setEventData, sendTimedEvent } from './events.js';


function prepararDescarga() {
	// inicializo objeto con los datos para la descarga
	let objdescarga = {};
	
	// obtengo zoom del mapa
	objdescarga.zoomCelda = Sesion.zoom > config.zMaxCelda? config.zMaxCelda : Sesion.zoom;
	
	// obtengo grid a partir del polígono
	if (Layers.editableLayer.getLayers().length == 0)
		return; // nada que hacer	
	const polygon = Layers.editableLayer.getLayers()[0]; // sólo debería haber un polígono
	objdescarga.grid = getGrid(polygon.getBounds(), objdescarga.zoomCelda);
	
	// obtengo el GeoJSON del polígono (para el procesamiento con turf)
	objdescarga.geojsonpoly = polygon.toGeoJSON();
	
	// detecto regiones del polígono y si hay territorio de España
	objdescarga.regions = [];
	objdescarga.inSpain = false;
	for (let featprov of featprovs) {
		if (booleanIntersects(featprov.geometry, objdescarga.geojsonpoly)) {
			objdescarga.regions.push(featprov.properties.iri);
			if (!featprov.properties.isPortuguese)
				objdescarga.inSpain = true;
		}
	}
	
	// preparo objeto plantilla para el modal
	const tobjbody = {
		nodata: objdescarga.regions.length == 0,
		inSpain: objdescarga.inSpain,
		plotsAvailable: objdescarga.inSpain && objdescarga.zoomCelda >= config.zParcela
	};
	const footer = tobjbody.nodata? footerDescargaDatosExito : footerDescargaDatos;
	
	// inicialización modal con petición de confirmación
	const htmlbody = Mustache.render(downloadTemplateBody, tobjbody);
	configurarModal( { static: true, vertcent: true}, 
		getLiteral(dict.downloadData), htmlbody, footer);		
	// muestro el modal
	const mimodal = new bootstrap.Modal(document.getElementById('mimodal'));
	mimodal.show();
	
	// listener al modal para que borre el polígono al cerrar
	document.getElementById('mimodal').addEventListener('hidden.bs.modal', event => {
 		Layers.editableLayer.clearLayers();
	});
	
	// pongo listener a los checks de IFN para mensajillo y para habilitar el botón de descarga
	document.querySelectorAll('.check-ifn').forEach(function(checkbox) {
		checkbox.addEventListener('change', function() {
			const algunifn = Array.from(document.querySelectorAll('.check-ifn'))
				.some((el) => el.checked);
			if (algunifn) {
				document.getElementById('downloadNoIFN').classList.add("d-none");
				const algunadescarga = Array.from(document.querySelectorAll('.check-download'))
					.some((el) => el.checked);
				const algunformato = Array.from(document.querySelectorAll('.radio-format'))
					.some((el) => el.checked);
				document.getElementById('downloadData').disabled = !(algunadescarga && algunformato);
			} 
			else {
				document.getElementById('downloadNoIFN').classList.remove("d-none");
				document.getElementById('downloadData').disabled = true;
			}
		});
	});
	
	// pongo listener a los checks de descarga para mensajillo y para habilitar el botón de descarga
	document.querySelectorAll('.check-download').forEach(function(checkbox) {
		checkbox.addEventListener('change', function() {
			const algunadescarga = Array.from(document.querySelectorAll('.check-download'))
				.some((el) => el.checked);
			if (algunadescarga) {
				document.getElementById('downloadNothing').classList.add("d-none");
				const algunifn = !tobjbody.inSpain || Array.from(document.querySelectorAll('.check-ifn'))
					.some((el) => el.checked);
				const algunformato = Array.from(document.querySelectorAll('.radio-format'))
					.some((el) => el.checked);
				document.getElementById('downloadData').disabled = !(algunifn && algunformato);
			} 
			else {
				document.getElementById('downloadNothing').classList.remove("d-none");
				document.getElementById('downloadData').disabled = true;
			}
		});
	});
	
	// pongo listener al radio para habilitar el botón de descarga	
	document.querySelectorAll('.radio-format').forEach(function(radio) {
		radio.addEventListener('change', function() {
			document.getElementById('downloadNoFormat').classList.add("d-none");
			const algunifn = !tobjbody.inSpain || Array.from(document.querySelectorAll('.check-ifn'))
				.some((el) => el.checked);
			const algunadescarga = Array.from(document.querySelectorAll('.check-download'))
				.some((el) => el.checked);
			document.getElementById('downloadData').disabled = !(algunifn && algunadescarga);
		});
	});
		
	// listener al botón de descarga
	document.getElementById('downloadData').addEventListener('click', function() {
		// extraigo ediciones ifn
		objdescarga.ifns = [];
		if (document.getElementById('checkIFN2') && document.getElementById('checkIFN2').checked)
			objdescarga.ifns.push("ifn2");
		if (document.getElementById('checkIFN3') && document.getElementById('checkIFN3').checked)
			objdescarga.ifns.push("ifn3");
		// miro qué cosas quiere descargar
		objdescarga.descargar = {
			plots: document.getElementById('checkPlots')? document.getElementById('checkPlots').checked : false,
			trees: document.getElementById('checkTrees')? document.getElementById('checkTrees').checked : false,
			regions: document.getElementById('checkRegions')? document.getElementById('checkRegions').checked : false,
			patches: document.getElementById('checkPatches')? document.getElementById('checkPatches').checked : false,
		};		
		// detecto el formato de descarga
		objdescarga.format = "GeoJSON"; // valor por defecto
		if (document.getElementById('CSV').checked)
			objdescarga.format = "CSV";
		else if (document.getElementById('XLSX').checked)
			objdescarga.format = "XLSX";
		// llamo a descargar los datos
		descargarDatos(objdescarga);
	});
}


async function descargarDatos(objd) {
	// actualizo modal
	configurarModal( { static: true, vertcent: true}, null, downloadingTemplateBody, footerDescargando);
		
	// inicializo datos para timed event
	const dte = { content_type: 'download', format: objd.format };	
	// inicializo TimedEvent GA
	initTimedEvent(dte);
	
	// inicializaciones salida	
	const CSV = objd.format === 'CSV';
	const outputs = []; 	// inicializo array de salidas
	const workbook = objd.format === 'XLSX'? new ExcelJS.Workbook() : null; // workbook para el Excel
	
	// inicializo piris (valdrá para parcelas y árboles)
	let piris = [];
	
	// inicializo sesión (ajustada a la descarga)
	const sesion = {
		idTimeoutActualizar: 0,
		zoomUsados: Sesion.zoomUsados,
		infoTeselas: {
			celdas: (1 + objd.grid.cellE - objd.grid.cellW) * (1 + objd.grid.cellN - objd.grid.cellS),
			celdasMediadas: [],
			teselasTotales: 1000, // para que no sea 0
			teselasCompletadas: 0,
			urlsRed: [],
			urlsCache: [],
			descargar: false, // para que inicialmente no cuente
			pintar: false
		},
		infoParcelas: {
			celdas: (1 + objd.grid.cellE - objd.grid.cellW) * (1 + objd.grid.cellN - objd.grid.cellS),
			celdasCompletadas: [],
			celdasArbolesCompletadas: [],
			parcelasCompletadas: [],
			parcelasArbolesCompletadas: [],
			urlsRed: [],
			urlsCache: [],
			iter: -1,  // nuevo, para que cuadre bien el progreso
			iters: objd.ifns.length, // nuevo, para que cuadre bien el progreso
			// falta la versión de ifn... (en el bucle de la edición)
			modoArbol: objd.descargar.trees,
			descargar: objd.descargar.plots || objd.descargar.trees,
			pintar: false
		}
	};	
	sesion.progreso = pintarBarraProgresoDescarga;
	
	// pongo un handler al botón de cancelar
	document.getElementById('downloadCancel').addEventListener('click', function(event) {
		sesion.idTimeoutActualizar = null; // para que no siga descargando
	});		
		
	// descarga datos de parcelas y árboles (si hiciera falta)
	if (objd.descargar.plots || objd.descargar.trees) {
		if (objd.descargar.plots)
			document.getElementById('downloadingPlots').classList.remove("d-none");
		if (objd.descargar.trees)
			document.getElementById('downloadingTrees').classList.remove("d-none");
			
		// itero por cada edición de inventario (una o más)
		for (let ifn of objd.ifns) {
			// actualizo info iteración
			sesion.infoParcelas.iter++;
			sesion.infoParcelas.celdasCompletadas = [];
			sesion.infoParcelas.celdasArbolesCompletadas = [];
			sesion.infoParcelas.parcelasCompletadas = [];
			sesion.infoParcelas.parcelasArbolesCompletadas = [];
			
			// incluyo ifn en la sesión
			sesion.infoParcelas.ifn = ifn;
					
			// inicializo array de promesas celdas
			const dpcpromises = [];
			//let objceldas = [];
			// trabajo celda a celda
			for (let x=objd.grid.cellW; x<=objd.grid.cellE; x++) {
				for (let y=objd.grid.cellS; y<=objd.grid.cellN; y++) {
					// preparo objeto de la celda
					const objcelda = {
						zoom: objd.zoomCelda,
						cellX: x,
						cellY: y,
						et: 'z' + objd.zoomCelda + '_x' + x + '_y' + y + '_' + sesion.infoParcelas.ifn,
						ifn: sesion.infoParcelas.ifn,
						modoArbol: sesion.infoParcelas.modoArbol,
						idtimeout:  0  // predefino el id de timeout
					};
					// guardo objcelda
					//objceldas.push(objcelda);
					// hago la petición para descubrir las parcelas de la celda
					dpcpromises.push( discoverPlotsInCell(objcelda, sesion) );
				}
			}
			// espero a que termine de extraer los datos de parcelas y árboles
			//await processPlots(0, objceldas, dpcpromises, sesion); // idtimeout: 0
			await Promise.all(dpcpromises);
			
			// si canceló, no hacemos más
			if (sesion.idTimeoutActualizar != 0)
				return;
		}
					
		// obtengo iris de parcelas
		for (let ifn of objd.ifns) {
			for (let x=objd.grid.cellW; x<=objd.grid.cellE; x++) {
				for (let y=objd.grid.cellS; y<=objd.grid.cellN; y++) {
					const et = 'z' + objd.zoomCelda + '_x' + x + '_y' + y + '_' + ifn;
					piris = piris.concat(Datos.celdasParcelas[et]);
				}
			}
		}
		
		// uso turf para obtener las parcelas que están en el polígono
		//console.log("#parcelas inicio: " + piris.length);
		piris = piris.filter((piri) => {
			const turfpoint = point([Datos.parcelas[piri].lng, Datos.parcelas[piri].lat]);
			return booleanPointInPolygon(turfpoint, objd.geojsonpoly);		
		});
		console.log("#parcelas fin: " + piris.length);		
		
		// ordeno
		//piris = piris.sort();
		piris = piris.sort((a, b) => {
			const ifna = a.match(/\/(ifn2|ifn3|ifn4)\//)[1];
			const pra = Number(a.split('/plot-')[1].split('-')[0]);
			const ida = Number(a.split('/plot-')[1].split('-')[1]);
			const ifnb = b.match(/\/(ifn2|ifn3|ifn4)\//)[1];
			const prb = Number(b.split('/plot-')[1].split('-')[0]);
			const idb = Number(b.split('/plot-')[1].split('-')[1]);
			if (ifna !== ifnb)
				return ifna.localeCompare(ifnb);
			else if (pra == prb)
				return ida - idb;
			else
				return pra - prb;
		});
	}
			
	// procesamiento parcelas
	if (objd.descargar.plots) {
		// preparación datos descarga
		// preparo las parcelas
		let parcelas = [];
		for (let piri of piris) {
			// rehago para controlar el orden de las claves del JSON
			let props = {};
			let parcela = {
				type: "Feature",
				properties: props,
				//properties: JSON.parse(JSON.stringify(Datos.parcelas[piri])), // deep copy
				geometry: {
					type: "Point",
					coordinates: [ Datos.parcelas[piri].lng, Datos.parcelas[piri].lat ]
				} 
			}
			// preparo propiedades
			props.plotId = uriToLiteral(piri, "plot-");
			props.plotIri = piri;
			props.ifn = Datos.parcelas[piri].ifn;
			//delete parcela.properties.iri;
			if (Datos.parcelas[piri].prov && Datos.provs[Datos.parcelas[piri].prov])
				props.province = getLiteral(Datos.provs[Datos.parcelas[piri].prov].label);		
			if (Datos.parcelas[piri].plotifn2) {
				const piri2 = Array.isArray(Datos.parcelas[piri].plotifn2)?
					Datos.parcelas[piri].plotifn2[0] : Datos.parcelas[piri].plotifn2;			
				props.plotifn2Id = uriToLiteral(piri2, "plot-");
				props.plotifn2Iri = piri2;
			}
			if (Datos.parcelas[piri].plotifn3) {	
				const piri3 = Array.isArray(Datos.parcelas[piri].plotifn3)?
					Datos.parcelas[piri].plotifn3[0] : Datos.parcelas[piri].plotifn3;
				props.plotifn3Id = uriToLiteral(piri3, "plot-");
				props.plotifn3Iri = piri3;
			}
			if (Datos.parcelas[piri].dataCapture)
				props.dataCapture = getDate(Datos.parcelas[piri].dataCapture);
			// infoSpecies
			if (Datos.parcelas[piri].nt) {
				props.infoSpecies = [];
				for (const sp in Datos.parcelas[piri].nt) {
					// preparo cada infospecies
					let is = {};
					props.infoSpecies.push(is);
					// especie
					is.speciesId = uriToLiteral(sp);
					is.speciesIri = sp;
					if (Datos.taxones[sp])
						is.scientificName = getLiteral(Datos.taxones[sp].scientificName);
					// inclusión numberTreesHa
					if (Datos.parcelas[piri].nt[sp])
						is.numberTreesHa = Datos.parcelas[piri].nt[sp];
					// inclusión basalAreaM2Ha
					if (Datos.parcelas[piri].ba[sp])
						is.basalAreaM2Ha = Datos.parcelas[piri].ba[sp];
					// inclusión volumeWithBarkM3Ha
					if (Datos.parcelas[piri].vwb[sp])
						is.volumeWithBarkM3Ha = Datos.parcelas[piri].vwb[sp];
					// inclusión volumeWithoutBarkM3Ha
					if (Datos.parcelas[piri].vwob[sp])
						is.volumeWithoutBarkM3Ha = Datos.parcelas[piri].vwob[sp];
				}
			}
			// árboles
			if (Datos.parcelas[piri].arbs)
				props.trees = JSON.parse(JSON.stringify(Datos.parcelas[piri].arbs)); // deep copy
			// guardo
			parcelas.push(parcela);
		}
		// generación datos descarga
		if (parcelas.length > 0)  {		
			let nfich = getLiteral(dict.plotsFile);
			if (objd.format === 'GeoJSON') { // GeoJSON
				const geoJSON = {
					type: 'FeatureCollection',
					features: parcelas
				};
				const output = {
					data: JSON.stringify(geoJSON, null, 2),
					nfich: nfich + ".json"
				};
				outputs.push(output);
			}
			else { // CSV o XLSX
				// fichero de parcelas
				// CSV header
				//let header = [ "iri", "ifn", "province", "latWGS84", "lngWGS84", "dataCapture", "plotifn2", "plotifn3"];
				let header = [ "plotId", "ifn", "province", "latWGS84", "lngWGS84", "dataCapture", 
					"plotifn2Id", "plotifn3Id", "plotIri", "plotifn2Iri", "plotifn3Iri"];
				// Generate the CSV rows
				let rows = parcelas.map(feature => {
					return header.map(key => {
						let value = undefined;
						if (key === "latWGS84")
							value = feature.geometry.coordinates[1];
						else if (key === "lngWGS84")
							value = feature.geometry.coordinates[0];
						else
							value = feature.properties[key];
						// procesamiento cadenas para CSV
						if (CSV) {
							if (typeof value === 'string' || value instanceof String)
								value = '"' + value.replace('"', '""') + '"';
						}
						// devuelvo
						return value;
					});
				});
				if (CSV) {
					// Combine the header and rows into a single CSV string
					const output = {
						data: [header.join(',')].concat(rows.map(row => row.join(','))).join('\n'),
						nfich: nfich + ".csv"
					};
					outputs.push(output);
				}
				else { // XLSX
					// Create a new worksheet
					const worksheet = workbook.addWorksheet(nfich);
					// añado los datos
					worksheet.addRow(header);
					rows.forEach(row => {
						worksheet.addRow(row);
					});
				}				
				// fichero de infoSpecies
				// CSV header
				//header = [ "iri", "plot", "province", "basalAreaM2byHa", "numberTreesHa", "volumeWithBarkM3byHa", 
				//	"volumeWithoutBarkM3byHa", "sampledTrees", "species", "scientificName"];
				header = [ "ifn", "plotId", "province", "speciesId", "scientificName",				
					 "numberTreesHa", "basalAreaM2Ha", "volumeWithBarkM3Ha", "volumeWithoutBarkM3Ha", 
					 "plotIri",  "speciesIri" ];
				// Generate the CSV rows
				const filParcelas = parcelas.filter((par) => par.properties.infoSpecies);
				rows = filParcelas.flatMap(feature => {
					const infoSpecies = feature.properties.infoSpecies || [];
					return infoSpecies.map(is => {
						return header.map(key => {
							let value = undefined;
							if (key === "ifn")
								value = feature.properties.ifn;
							else if (key === "plotId")
								value = feature.properties.plotId;
							else if (key === "plotIri")
								value = feature.properties.plotIri;
							else if (key === "province")
								value = feature.properties.province;
							else
								value = is[key];
							// procesamiento cadenas para CSV
							if (CSV) {
								if (typeof value === 'string' || value instanceof String)
									value = '"' + value.replace('"', '""') + '"';
							}
							// devuelvo
							return value;
						});
					});
				});
				if (rows.length > 0) {
					if (CSV) {
						// Combine the header and rows into a single CSV string
						const output = {
							data: [header.join(',')].concat(rows.map(row => row.join(','))).join('\n'),
							nfich: getLiteral(dict.infoplotsFile) + ".csv"
						};
						outputs.push(output);
					}
					else { // XLSX
						// Create a new worksheet
						const worksheet = workbook.addWorksheet(getLiteral(dict.infoplotsFile));
						// añado los datos
						worksheet.addRow(header);
						rows.forEach(row => {
							worksheet.addRow(row);
						});
					}
				}
			}
			document.getElementById('plotsDownloaded').classList.remove("d-none");
		}
		else
			document.getElementById('noPlotsDownloaded').classList.remove("d-none");
		// actualizo mensajillos de info
		document.getElementById('downloadingPlots').classList.add("d-none");
	}
	
	// procesamiento árboles
	if (objd.descargar.trees) {	
		// preparación datos descarga
		// preparo los árboles a partir de las parcelas
		let arboles = [];
		for (let piri of piris) {
			for (let airi of Datos.parcelas[piri].arbs) {				
				const tree = Datos.arboles[airi];
				let apr = {};
				let arbol = {
					type: "Feature",
					properties: apr,
					//properties: JSON.parse(JSON.stringify(Datos.arboles[airi])), // deep copy
					geometry: {
						type: "Point",
						coordinates: [ tree.lng, tree.lat ]
					} 
				}
				// guardo
				arboles.push(arbol);
				// preparo propiedades
				//apr.treeId = uriToLiteral(uriToLiteral(airi, "deadTree-"), "tree-");
				apr.treeId = uriToLiteral(airi, "tree-");
				apr.treeIri = airi;
				apr.ifn = Datos.parcelas[piri].ifn;
				apr.plotId = uriToLiteral(piri, "plot-");
				apr.plotIri = piri;
				if (Datos.parcelas[piri].prov && Datos.provs[Datos.parcelas[piri].prov])
					apr.province = getLiteral(Datos.provs[Datos.parcelas[piri].prov].label);	
				if (tree.species) {
					apr.speciesId = uriToLiteral(tree.species);
					apr.speciesIri = tree.species;						
					if (Datos.taxones[tree.species])
						apr.scientificName = getLiteral(Datos.taxones[tree.species].scientificName);
				}
				apr.dbh1mm = tree.dbh1mm;
				apr.dbh2mm = tree.dbh2mm;
				apr.heightM = tree.heightM;				
				if (Datos.parcelas[piri].dataCapture)
					apr.dataCapture = getDate(Datos.parcelas[piri].dataCapture);
				if (tree.treeifn2) {
					if (Array.isArray(tree.treeifn2)) {
						apr.treeifn2Id = [];
						for (const tiri of tree.treeifn2) {
							//const tirid = uriToLiteral(uriToLiteral(tiri, "deadTree-"), "tree-");
							const tirid = uriToLiteral(tiri, "tree-");
							apr.treeifn2Id.push(tirid);
						}
					}
					else {
						//const tirid = uriToLiteral(uriToLiteral(tree.treeifn2, "deadTree-"), "tree-");
						const tirid = uriToLiteral(tree.treeifn2, "tree-");
						apr.treeifn2Id = tirid;
					}
					apr.treeifn2Iri = tree.treeifn2;
				}
				if (tree.treeifn3) {
					if (Array.isArray(tree.treeifn3)) {
						apr.treeifn3Id = [];
						for (const tiri of tree.treeifn3) {
							//const tirid = uriToLiteral(uriToLiteral(tiri, "deadTree-"), "tree-");
							const tirid = uriToLiteral(tiri, "tree-");
							apr.treeifn3Id.push(tirid);
						}
					}
					else {
						//const tirid = uriToLiteral(uriToLiteral(tree.treeifn3, "deadTree-"), "tree-");
						const tirid = uriToLiteral(tree.treeifn3, "tree-");
						apr.treeifn3Id = tirid;
					}
					apr.treeifn3Iri = tree.treeifn3;
				}
			}
		}		
		// generación datos descarga
		if (arboles.length > 0)  {		
			let nfich = getLiteral(dict.treesFile);
			if (objd.format === 'GeoJSON') { // GeoJSON
				const geoJSON = {
					type: 'FeatureCollection',
					features: arboles
				};
				const output = {
					data: JSON.stringify(geoJSON, null, 2),
					nfich: nfich + ".json"
				};
				outputs.push(output);
			}
			else { // CSV o XLSX
				// fichero de árboles
				// CSV header
				//let header = [ "iri", "ifn", "plot", "province", "latWGS84", "lngWGS84", "dbh1mm", "dbh2mm", 
				//	"heightM", "species", "scientificName", "dataCapture", "treeifn2", "treeifn3"];
				let header = [ "treeId", "ifn", "plotId", "province", "latWGS84", "lngWGS84", "dbh1mm", "dbh2mm", 
					"heightM", "speciesId", "scientificName", "dataCapture", "treeifn2Id", "treeifn3Id",
					"treeIri", "plotIri", "speciesIri", "treeifn2Iri", "treeifn3Iri" ];
				// Generate the CSV rows
				let rows = Object.values(arboles).map(feature => {
					return header.map(key => {
						let value = undefined;
						if (key === "latWGS84")
							value = feature.geometry.coordinates[1];
						else if (key === "lngWGS84")
							value = feature.geometry.coordinates[0];
						else
							value = feature.properties[key];
						// procesamiento cadenas para CSV
						if (CSV) {
							if (typeof value === 'string' || value instanceof String)
								value = '"' + value.replace('"', '""') + '"';
						}
						// devuelvo
						return value;
					});
				});
				if (rows.length > 0) {
					if (CSV) {
						// Combine the header and rows into a single CSV string
						const output = {
							data: [header.join(',')].concat(rows.map(row => row.join(','))).join('\n'),
							nfich: nfich + ".csv"
						};
						outputs.push(output);
					}
					else { // XLSX
						// Create a new worksheet
						const worksheet = workbook.addWorksheet(nfich);
						// añado los datos
						worksheet.addRow(header);
						rows.forEach(row => {
							worksheet.addRow(row);
						});
					}
				}
			}
			document.getElementById('treesDownloaded').classList.remove("d-none");
		}
		else
			document.getElementById('noTreesDownloaded').classList.remove("d-none");
		// actualizo mensajillos de info
		document.getElementById('downloadingTrees').classList.add("d-none");
	}
	
	// procesamiento regiones
	if (objd.descargar.regions) {
		document.getElementById('downloadingRegions').classList.remove("d-none");
		// deep copy de las regiones
		let regiones = JSON.parse(JSON.stringify(featprovs));
		// extraigo sólo las regiones del polígono
		regiones = regiones.filter((reg) => objd.regions.includes(reg.properties.iri));
		
		// ordeno
		regiones.sort((a, b) => a.properties.iri.localeCompare(b.properties.iri));
		//regiones = _.sortBy(regiones, function(reg){ return reg.properties.iri; });
		
		// reajuste
		for (const reg of regiones) {
			reg.properties.regionId = uriToLiteral(reg.properties.iri);
			reg.properties.regionIri = reg.properties.iri;
			delete reg.properties.iri;
			reg.properties.regionLabel = getLiteral(reg.properties.label);
			reg.properties.country = reg.properties.isPortuguese? getLiteral(dict.portugal) : getLiteral(dict.spain);
			// apaño para Portugal
			if (reg.properties.isPortuguese && reg.properties.infoSpecies) {
				reg.properties.ifn6 = {};
				reg.properties.ifn6.infoSpecies = reg.properties.infoSpecies;
				delete reg.properties.infoSpecies;
			}
			delete reg.properties.isPortuguese;
			delete reg.properties.mfeSourceDate;
			for (const ifn of ["ifn6", ...config.ifnVersions]) { // incluyo ifn6 (para Portugal)
				if (ifn !== "ifn6" && !objd.ifns.includes(ifn))
					delete reg.properties[ifn];
				else if (reg.properties[ifn]) {
					delete reg.properties[ifn].iri;
					delete reg.properties[ifn].nplots;
					delete reg.properties[ifn].ntrees;		
					if (reg.properties[ifn].infoSpecies) {
						reg.properties[ifn].infoSpecies = Array.isArray(reg.properties[ifn].infoSpecies)?
							reg.properties[ifn].infoSpecies : [reg.properties[ifn].infoSpecies];
						for (const is of reg.properties[ifn].infoSpecies) {
							// ajuste id e iri
							is.infoSpeciesId = uriToLiteral(is.iri);
							is.infoSpeciesIri = is.iri;
							delete is.iri;
							// incluyo ifn
							is.ifn = ifn;
							// TODO: cuidado, algunas provincias tienen info de especies que no existen => preguntar a JM
							if (Datos.taxones[is.species])
								is.scientificName = getLiteral(Datos.taxones[is.species].scientificName);
							if (is.species) {
								is.speciesId = uriToLiteral(is.species);
								is.speciesIri = is.species;
								delete is.species
							}
							// ajuste claves para incluir medidas
							if (is.basalArea) {
								is.basalAreaM2 = is.basalArea;
								delete is.basalArea;
							}
							if (is.volumeWithBark) {
								is.volumeWithBarkM3 = is.volumeWithBark;
								delete is.volumeWithBark;
							}
							if (is.volumeWithoutBark) {
								is.volumeWithoutBarkM3 = is.volumeWithoutBark;
								delete is.volumeWithBark;
							}
						}
					}
				}
			}
		}
		// generación datos descarga
		let nfich = getLiteral(dict.regionsFile);
		if (objd.format === 'GeoJSON') { // GeoJSON
			const geoJSON = {
				type: 'FeatureCollection',
				features: regiones
			};
			const output = {
				data: JSON.stringify(geoJSON, null, 2),
				nfich: nfich + ".json"
			};
			outputs.push(output);
		}
		else { // CSV o XLSX
			// fichero de regiones
			// CSV header
			let header = [ "regionId", "regionLabel", "country", "wkt", "regionIri"];
			// Generate the CSV rows
			let rows = regiones.map(feature => {
				return header.map(key => {
					let value = undefined;
					if (key === "wkt") {
						value = stringify(feature.geometry);
						if (!CSV && value.length > 32760)
							value = getLiteral(dict.wktTooLongForExcel);
					}
					else
						value =  feature.properties[key];
					// procesamiento cadenas para CSV
					if (CSV) {
						if (typeof value === 'string' || value instanceof String)
							value = '"' + value.replace('"', '""') + '"';
					}
					// devuelvo
					return value;
				});
			});
			// Combine the header and rows into a single CSV string
			if (CSV) {
				const output = {
					data: [header.join(',')].concat(rows.map(row => row.join(','))).join('\n'),
					nfich: nfich + ".csv"
				};
				outputs.push(output);
			}
			else { // XLSX
				// Create a new worksheet
				const worksheet = workbook.addWorksheet(nfich);
				// añado los datos
				worksheet.addRow(header);
				rows.forEach(row => {
					worksheet.addRow(row);
				});
			}			
			// fichero de infoSpecies
			nfich = getLiteral(dict.inforegionsFile);
			// CSV header
			header = [ "infoSpeciesId", "ifn", "regionId", "regionLabel", "basalAreaM2", "numberTrees", 
				"volumeWithBarkM3", "volumeWithoutBarkM3", "speciesId", "scientificName",
				"infoSpeciesIri", "regionIri",  "speciesIri" ];
			// Generate the CSV rows
			rows = regiones.flatMap(feature => {
				let infoSpecies = [];
				for (const ifn of ["ifn6", ...objd.ifns]) {
					if (feature.properties[ifn] && feature.properties[ifn].infoSpecies) 
						infoSpecies = infoSpecies.concat(feature.properties[ifn].infoSpecies);		
				}
				return infoSpecies.map(is => {
					return header.map(key => {
						let value = undefined;
						if (key === "regionId")
							value = feature.properties.regionId;
						else if (key === "regionIri")
							value = feature.properties.regionIri;
						else if (key === "regionLabel")
							value = feature.properties.regionLabel;
						else
							value = is[key];
						// procesamiento cadenas para CSV
						if (CSV) {
							if (typeof value === 'string' || value instanceof String)
								value = '"' + value.replace('"', '""') + '"';
						}
						// devuelvo
						return value;
					});
				});
			});		
			if (rows.length > 0) {
				if (CSV) { // Combine the header and rows into a single CSV string
					const output = {
						data: [header.join(',')].concat(rows.map(row => row.join(','))).join('\n'),
						nfich: nfich + ".csv"
					};
					outputs.push(output);
				}
				else { // XLSX
					// Create a new worksheet
					const worksheet = workbook.addWorksheet(nfich);
					// añado los datos
					worksheet.addRow(header);
					rows.forEach(row => {
						worksheet.addRow(row);
					});
				}
			}
		}
		// actualizo mensajillos de info
		document.getElementById('downloadingRegions').classList.add("d-none");
		document.getElementById('regionsDownloaded').classList.remove("d-none");
	}
	
	// procesamiento teselas
	if (objd.descargar.patches) {
		document.getElementById('downloadingPatches').classList.remove("d-none");
				
		// actualizo booleanos progreso
		sesion.infoParcelas.descargar = false; // para que no cuente las parcelas
		sesion.infoTeselas.descargar = true; // para que trate las teselas
		
		// inicializo array de promesas celdas para luego coordinar
		let dpcpromises = [];
		let objceldas = [];
		// trabajo celda a celda
		for (let x=objd.grid.cellW; x<=objd.grid.cellE; x++) {
			for (let y=objd.grid.cellS; y<=objd.grid.cellN; y++) {
				// preparo objeto de la celda
				const objcelda = {
					zoom: objd.zoomCelda,
					cellX: x,
					cellY: y,
					et: 'z' + objd.zoomCelda + '_x' + x + '_y' + y,
					idtimeout: 0  // predefino el id de timeout
				};
				// guardo objcelda
				objceldas.push(objcelda);
				// hago la petición para descubrir las teselas de la celda
				dpcpromises.push( discoverPatchesInCell(objcelda, sesion) );
			}
		}	
		// espero a que termine de extraer los datos de teselas
		await processPatches(0, objceldas, dpcpromises, sesion); // idtimeout: 0
		// si canceló, no hacemos más
		if (sesion.idTimeoutActualizar != 0)
			return;
		
		// obtengo iris de las teselas
		let turis = [];
		for (let x=objd.grid.cellW; x<=objd.grid.cellE; x++) {
			for (let y=objd.grid.cellS; y<=objd.grid.cellN; y++) {
				const et = 'z' + objd.zoomCelda + '_x' + x + '_y' + y;
				turis = turis.concat(Datos.celdasTeselas[et]);
			}
		}
				
		// uso turf para obtener las teselas que intersecan con el polígono
		//console.log("#teselas inicio: " + turis.length);
		turis = turis.filter((turi) => booleanIntersects(Datos.teselas[turi].geometry, objd.geojsonpoly));
		//console.log("#teselas fin: " + turis.length);		
				
		// ordeno
		turis = turis.sort();
		
		// preparo las teselas
		let teselas = [];
		for (let turi of turis) {
			let tesela = {
				type: "Feature",
				properties: JSON.parse(JSON.stringify(Datos.teselas[turi])), // deep copy
				geometry: Datos.teselas[turi].geometry
			}
			tesela.properties.patchId = uriToLiteral(tesela.properties.iri);
			tesela.properties.patchIri = tesela.properties.iri;
			delete tesela.properties.iri;
			// elimino el geometry repetido
			delete tesela.properties.geometry;
			// incluyo versión del mapa
			tesela.properties.map = turi.startsWith('http://crossforest.eu/cos')? 'COS2018' : 'MFE50';			
			// ajuste suelo
			if (tesela.properties.soilUse) {
				tesela.properties.soilUse = Array.isArray(tesela.properties.soilUse)? tesela.properties.soilUse[0] : tesela.properties.soilUse;
				if (Datos.usos[tesela.properties.soilUse]) {
					tesela.properties.soilUseId = uriToLiteral(tesela.properties.soilUse);
					tesela.properties.soilUseLabel = getLiteral(Datos.usos[tesela.properties.soilUse].label);
					tesela.properties.soilUseIri = tesela.properties.soilUse;
				}
				delete tesela.properties.soilUse;
			}
			delete tesela.properties.infoSoil; // quito desglose de info de usos de suelos portugueses
			if (tesela.properties.infoSpecies) {
				// convierto a array si hace falta
				tesela.properties.infoSpecies = Array.isArray(tesela.properties.infoSpecies)?
					tesela.properties.infoSpecies : [tesela.properties.infoSpecies];
				for (let is of tesela.properties.infoSpecies) {
					// ajuste id e iri
					is.infoSpeciesId = uriToLiteral(is.iri);
					is.infoSpeciesIri = is.iri;
					delete is.iri;
					// TODO: cuidado, algunas teselas tienen info de especies que no existen => preguntar a JM
					if (Datos.taxones[is.species])
						is.scientificName = getLiteral(Datos.taxones[is.species].scientificName);
					if (is.species) {
						is.speciesId = uriToLiteral(is.species);
						is.speciesIri = is.species;
						delete is.species
					}
				}
			}
			if (tesela.properties.province && Datos.provs[tesela.properties.province])
				tesela.properties.province = getLiteral(Datos.provs[tesela.properties.province].label);
			if (tesela.properties.area)
				tesela.properties.areaHa = Number((tesela.properties.area/10000).toFixed(2));
			delete tesela.properties.area;
			delete tesela.properties.poly;
			//tesela.properties.layerIri = objd.zoomCelda < config.zCambioCapaTeselas? config.lowresPatchLayer : config.simplifiedPatchLayer;
			tesela.properties.layerIri = getMapLayer(objd.zoomCelda).layer;
			tesela.properties.layerId = uriToLiteral(tesela.properties.layerIri);
			// guardo
			teselas.push(tesela);
		}
		// generación datos descarga
		if (teselas.length > 0)  {		
			let nfich = getLiteral(dict.patchesFile);
			if (objd.format === 'GeoJSON') { // GeoJSON
				const geoJSON = {
					type: 'FeatureCollection',
					features: teselas
				};
				const output = {
					data: JSON.stringify(geoJSON, null, 2),
					nfich: nfich + ".json"
				};
				outputs.push(output);
			}
			else { // CSV o XLSX
				// fichero de teselas
				// CSV header
				let header = [ "patchId", "map", "layerId", "province", "west", "east", "north", "south", "areaHa",
					"soilUseId", "soilUseLabel", "canopyCoverTreesPercent", "wkt", "patchIri", "layerIri", "soilUseIri"];
				// Generate the CSV rows
				let rows = teselas.map(feature => {
					return header.map(key => {
						let value = undefined;
						if (key === "wkt") {
							value = stringify(feature.geometry);
							if (!CSV && value.length > 32760)
								value = getLiteral(dict.wktTooLongForExcel);
						}
						else
							value = feature.properties[key];
						// procesamiento cadenas para CSV
						if (CSV) {
							if (typeof value === 'string' || value instanceof String)
								value = '"' + value.replace('"', '""') + '"';
						}
						// devuelvo
						return value;
					});
				});
				if (rows.length > 0) {
					if (CSV) { // Combine the header and rows into a single CSV string
						const output = {
							data: [header.join(', ')].concat(rows.map(row => row.join(', '))).join('\n'),
							nfich: nfich + ".csv"
						};
						outputs.push(output);
					}
					else { // XLSX
						// Create a new worksheet
						const worksheet = workbook.addWorksheet(nfich);
						// añado los datos
						worksheet.addRow(header);
						rows.forEach(row => {
							worksheet.addRow(row);
						});
					}
				}			
				// fichero de infoSpecies
				nfich = getLiteral(dict.infopatchesFile);
				// CSV header
				header = [ "infoSpeciesId", "patchId", "speciesId", "scientificName", "percOccupation",
					 "infoSpeciesIri", "patchIri" ];
				// Generate the CSV rows
				const filTeselas = teselas.filter((tes) => tes.properties.infoSpecies);
				rows = filTeselas.flatMap(feature => {
					return feature.properties.infoSpecies.map(is => {
						return header.map(key => {
							let value = undefined;
							if (key === "patchId")
								value = feature.properties.patchId;
							else if (key === "patchIri")
								value = feature.properties.patchIri;
							else
								value = is[key];
							// procesamiento cadenas para CSV
							if (CSV) {
								if (typeof value === 'string' || value instanceof String)
									value = '"' + value.replace('"', '""') + '"';
							}
							// devuelvo
							return value;
						});
					});
				});
				if (rows.length > 0) {
					if (CSV) { // Combine the header and rows into a single CSV string
						const output = {
							data: [header.join(',')].concat(rows.map(row => row.join(','))).join('\n'),
							nfich: nfich + ".csv"
						};
						outputs.push(output);
					}
					else { // XLSX
						// Create a new worksheet
						const worksheet = workbook.addWorksheet(nfich);
						// añado los datos
						worksheet.addRow(header);
						rows.forEach(row => {
							worksheet.addRow(row);
						});
					}
				}
			}
			document.getElementById('patchesDownloaded').classList.remove("d-none");
		}
		else
			document.getElementById('noPatchesDownloaded').classList.remove("d-none");
		// actualizo mensajillos de info
		document.getElementById('downloadingPatches').classList.add("d-none");
	}
	
	// si canceló, no hacemos más
	if (sesion.idTimeoutActualizar != 0)
		return;
	
	// preparo la salida para XLSX a partir del workbook
	if (objd.format === 'XLSX') {
		const buffer = await workbook.xlsx.writeBuffer();
		outputs.push({
			data: buffer,
			nfich: getLiteral(dict.downloadFile) + ".xlsx"
		});
	}
	
	// si sólo hay un fichero, sin zip
	if (outputs.length == 1) {
		const out = outputs[0];
		const blob = new Blob([out.data], {type: "text/plain;charset=utf-8"});
		saveAs(blob, out.nfich);
	}
	else { // si hay varios ficheros preparo un zip
		const zip = new JSZip();
		for (const out of outputs) {
			const blob = new Blob([out.data], {type: "text/plain;charset=utf-8"});
			zip.file(out.nfich, blob);
		}
		const datoszip = await zip.generateAsync({type : "uint8array"});
		const blob = new Blob([datoszip], {type: "text/plain;charset=utf-8"});
		saveAs(blob, getLiteral(dict.downloadFile) + ".zip");
	}

	/*
	// hago las descargas
	for (let out of outputs) {
		const blob = new Blob([out.data], {type: "text/plain;charset=utf-8"});
		saveAs(blob, out.nfich);
	}*/
	// actualizo mensajillo de info
	document.getElementById('downloadSuccess').classList.remove("d-none");
	
	// escondo barra de progreso
	pintarBarraProgresoDescarga(false);
		
	// actualizo modal
	configurarModal( { static: true, vertcent: true}, 
		getLiteral(dict.downloadSuccess), null, footerDescargaDatosExito);
		
	// incluyo info GA
	setEventData('num_cells', sesion.infoParcelas.celdas);
	let urlsRed = sesion.infoTeselas.urlsRed.reduce((memo, num) => memo + num, 0);
	urlsRed += sesion.infoParcelas.urlsRed.reduce((memo, num) => memo + num, 0);
	setEventData('urls_network', urlsRed);
	let urlsCache = sesion.infoTeselas.urlsCache.reduce((memo, num) => memo + num, 0);
	urlsCache += sesion.infoParcelas.urlsCache.reduce((memo, num) => memo + num, 0);	
	setEventData('urls_cache', urlsCache);	
	// mando evento temporizado
	sendTimedEvent();
}

function pintarBarraProgresoDescarga(mostrar, sesion) {
	// variante sin JQuery para que vaya más rápida la actualización de la barra
	const mibarradiv = document.getElementById('mibarradescarga_div');
	if (mostrar) {
		let total = 0;
		let comp = 0;
		
		// teselas
		if (sesion.infoTeselas.descargar) {
			total += 100;
			const celdasmed = sesion.infoTeselas.celdasMediadas.reduce((memo, num) => memo + num, 0);
			//console.log("teselas celdas: " + sesion.infoTeselas.celdas  + " - celdasmed: " + celdasmed);			
			if (sesion.infoTeselas.teselasTotales == 0)
				comp += 100*celdasmed/sesion.infoTeselas.celdas;
			else {
				comp += (35*celdasmed/sesion.infoTeselas.celdas 
					+ 65*sesion.infoTeselas.teselasCompletadas/sesion.infoTeselas.teselasTotales); // de 0 a 100				
				//console.log("teselas: " + sesion.infoTeselas.teselasTotales + " - comp: " + sesion.infoTeselas.teselasCompletadas);
			}
		}
		
		// parcelas
		if (sesion.infoParcelas.descargar) {
			total += sesion.infoParcelas.iters * 100; // iters...
			comp += sesion.infoParcelas.iter * 100; // iter
			const clistas = sesion.infoParcelas.celdasCompletadas.reduce((memo, num) => memo + num, 0);
			comp += 100*clistas/sesion.infoParcelas.celdas;
			//console.log("parcelas celdas: " + sesion.infoParcelas.celdas  + " - clistas: " + clistas);	
			if (sesion.infoParcelas.modoArbol) {
				total += sesion.infoParcelas.iters * 40; // iters...
				comp += sesion.infoParcelas.iter * 40; // iter
				const carblistas = sesion.infoParcelas.celdasArbolesCompletadas.reduce((memo, num) => memo + num, 0);
				comp += 40*carblistas/sesion.infoParcelas.celdas;
				//console.log("árboles celdas: " + sesion.infoParcelas.celdas  + " - carblistas: " + carblistas);	
			}
		}
		//console.log("fin total: " + total + " - comp: " + comp);
		// calculo porc (hasta 99)
		const porc = total == 0? 0 : Math.floor( 99 * comp / total );
		// ajusto barra
		let mibarra = document.getElementById('mibarradescarga');
		mibarradiv.setAttribute('aria-valuenow', porc);
		mibarra.style.width = porc + '%';
		mibarra.innerHTML = porc + '%';
		// muestro la barra de progreso
		mibarradiv.classList.remove('d-none');		
	} 
	else // escondo la barra
		mibarradiv.classList.add('d-none');
}

export { prepararDescarga };